var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarerental(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4002f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0804b5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Car_Rental_System",
    "data-name": "Car Rental System",
    transform: "translate(-347.202 -2126.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    "data-name": "Union 4",
    d: "M0,32A32,32,0,1,1,32,64,32.094,32.094,0,0,1,0,32Zm3.474,0A28.526,28.526,0,1,0,32,3.474,28.609,28.609,0,0,0,3.474,32ZM7,32A25,25,0,1,1,32,57,25.008,25.008,0,0,1,7,32Zm3.605-4.66A24.79,24.79,0,0,0,10.13,32c0,.951.1,1.9.19,2.852h3.328a15.5,15.5,0,0,1,15.5,15.5V53.68A28.547,28.547,0,0,0,32,53.87a28.538,28.538,0,0,0,2.853-.19V50.353a15.5,15.5,0,0,1,15.5-15.5h3.328c.094-.951.19-1.9.19-2.852a25,25,0,0,0-.475-4.66,61.95,61.95,0,0,0-21.431-3.922A61.348,61.348,0,0,0,10.607,27.34ZM27,53.244V51.3A14.3,14.3,0,0,0,12.7,37H10.757A21.666,21.666,0,0,0,27,53.244ZM37,51.3v1.944A21.667,21.667,0,0,0,53.244,37H51.3A14.3,14.3,0,0,0,37,51.3ZM52.45,24.349a21.876,21.876,0,0,0-40.983,0,66.376,66.376,0,0,1,20.484-3.293A66.373,66.373,0,0,1,52.45,24.349ZM31,50.4V47.7a1.16,1.16,0,0,1,.049-.342v-.428a.951.951,0,1,1,1.9,0v.424A1.172,1.172,0,0,1,33,47.7v2.7a1,1,0,0,1-2,0ZM26.2,32A5.8,5.8,0,1,1,32,37.8,5.8,5.8,0,0,1,26.2,32Zm2.185,0A3.614,3.614,0,1,0,32,28.387,3.611,3.611,0,0,0,28.387,32ZM45.7,33.9a1.116,1.116,0,0,1-.459-.093h-.214a.952.952,0,0,1,0-1.9h.582c.03,0,.061,0,.092,0h.7a1,1,0,0,1,0,2Zm-28.1,0a1,1,0,1,1,0-2h.7c.031,0,.062,0,.091,0h.58a.952.952,0,0,1,0,1.9h-.214a1.107,1.107,0,0,1-.458.093Zm31.23-2.375a.951.951,0,1,1,0-1.9h.349A1.084,1.084,0,0,1,49.7,29.5h.7a1,1,0,0,1,0,2h-.664a1.156,1.156,0,0,1-.24.024Zm-34.327,0a1.151,1.151,0,0,1-.24-.024H13.6a1,1,0,0,1,0-2h.7a1.085,1.085,0,0,1,.521.123h.349a.951.951,0,0,1,0,1.9Zm30.523-2.377a.951.951,0,0,1-.021-1.9A1.016,1.016,0,0,1,45.7,27h.7a1,1,0,0,1,0,2h-.16a1.01,1.01,0,0,1-.547.148Zm-26.72,0A1.008,1.008,0,0,1,17.761,29H17.6a1,1,0,1,1,0-2h.7a1.011,1.011,0,0,1,.693.245.951.951,0,0,1-.021,1.9Z",
    transform: "translate(347.201 2126.947)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarerental);
export default __webpack_public_path__ + "static/media/carerental.c42aa2bd4e03d21848947ddc5eb186fc.svg";
export { ForwardRef as ReactComponent };